import { ProductCategory } from '@fe/weather';
import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { ChevronDownOutline, ChevronUpOutline } from '../../../../icons/icons';

interface Props {
    children: React.ReactNode;
    title: string;
    category?: ProductCategory;
}

export default function WeatherSettingsSection(props: Props) {
    const [expanded, setExpanded] = React.useState(false);
    const [showHighlight, setShowHighlight] = React.useState(false);

    React.useEffect(() => {
        const handler = (e: Event) => {
            const show = (e as CustomEvent).detail === props.category;
            setExpanded(show);
            if (show) {
                setShowHighlight(true);
                self.setTimeout(() => {
                    setShowHighlight(false);
                }, 1000);
            }
        };
        document.addEventListener('open-weather-settings-section', handler);
        return () => document.removeEventListener('open-weather-settings-section', handler);
    }, []);
    return (
        <div className="border-bottom" id={props.category != null ? `weather-section-${props.category}` : undefined}>
            <div
                style={{
                    backgroundColor: 'light-dark(var(--color-neutral-900), var(--color-neutral-100))',
                    outlineOffset: '-1px',
                    outline: showHighlight ? '1px solid var(--fe-primary)' : undefined
                }}
                className="py-2 px-3 d-flex gap-1 align-items-center cursor-pointer"
                onClick={() => setExpanded(!expanded)}>
                <Button
                    className="button-small"
                    fillMode={'flat'}
                    svgIcon={expanded ? ChevronUpOutline : ChevronDownOutline}
                    onClick={() => setExpanded(!expanded)}
                />
                {props.title}
            </div>
            {expanded && <div className="px-3 pt-2 pb-3">{props.children}</div>}
        </div>
    );
}
